<div class="welcome-container">
  <div class="welcome-box" data-qa="welcome-box">
    <div class="title" data-qa="welcome-title">Welcome aboard!</div>
    <div class="success-icon" data-qa="success-icon"></div>
    <div class="text" data-qa="welcome-message">
      <ng-container *ngIf="isReLogin; else confirmationEmail">
        We sent a request to <b>{{ companyName }}</b
        >. When approved you will receive an email.
      </ng-container>
      <ng-template #confirmationEmail>
        We sent you a verification e-mail,<br />
        please use the link to connect.
      </ng-template>
    </div>
    <div class="footer" *ngIf="isReLogin; else confirmationFooter" data-qa="welcome-footer">
      <div class="hint" data-qa="close-hint">You can now close this window</div>
    </div>
    <ng-template #confirmationFooter>
      <div class="footer" data-qa="email-footer">
        <div class="col-left" data-qa="resend-email">
          <a href="javascript:void()">Re-send email</a>
        </div>
        <div class="col-right" data-qa="open-email">
          <s-button type="primary" label="Open e-mail"></s-button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
